import Card from '@shared/uikit/card';
import { Loader } from '@shared/uikit/loader';
import { formatNum } from '@app/utils/math';
import {
  useGetManagerClientsCount,
  useGetManagerClientsHashrate,
} from '@entities/managers-perfomance';

type StatCardType = 'clientsCount' | 'clientsHashrate';

type Props = {
  type: StatCardType;
  managerId: number | null;
  title?: string;
};

type ClientsCountData = {
  clients_count?: number;
};

type ClientsHashrateData = {
  total_hashrate?: number;
};

const STAT_CARD_CONFIG = {
  clientsCount: {
    defaultTitle: 'Количество клиентов',
    useQuery: (managerId: number | null) =>
      useGetManagerClientsCount({ managerId }) as { data?: ClientsCountData; isLoading: boolean },
    format: (data?: ClientsCountData) =>
      data?.clients_count !== undefined ? data.clients_count.toString() : '-',
    showPh: false,
  },
  clientsHashrate: {
    defaultTitle: 'Общий клиентский хешрейт',
    useQuery: (managerId: number | null) =>
      useGetManagerClientsHashrate({ managerId }) as {
        data?: ClientsHashrateData;
        isLoading: boolean;
      },
    format: (data?: ClientsHashrateData) =>
      data?.total_hashrate !== undefined ? formatNum(data.total_hashrate) : '-',
    showPh: true,
  },
} as const;

export const StatCard = ({ type, managerId, title }: Props) => {
  const config = STAT_CARD_CONFIG[type];
  const { data, isLoading } = config.useQuery(managerId);

  const displayValue = config.format(data);
  const showPh = config.showPh;
  const displayTitle = title || config.defaultTitle;

  return (
    <Card
      className="max-h-[83px]"
      header={
        <div className="flex flex-col">
          <span className="text-sm text-gray-400">{displayTitle}</span>

          {!isLoading ? (
            <div className="flex items-start gap-1">
              <span className="text-2xl text-white">{displayValue}</span>
              {showPh && displayValue !== '-' && <span className="text-sm text-gray-400">Ph</span>}
            </div>
          ) : (
            <div className="h-[32px] flex items-center">
              <Loader size={30} loading />
            </div>
          )}
        </div>
      }
    />
  );
};
